export default "__VITE_ASSET__LvMvmop9__"